<script>
import { mapState, mapActions } from 'vuex'
import vSelect from 'vue-select'

export default {
   components: {
      vSelect,
   },
   data() {
      return {
         loading: false,
         instansi: 'DPMPTSP',
         instansiOptions: [
            'SAMSAT',
            'BANK KALBAR',
            'DPMPTSP',
            'BAPPENDA',
            'BPJS Kesehatan',
            'Kejaksaan',
            'POLRES',
            'DPK',
            'BPJS Ketenagakerjaan',
            'DISDUKCAPIL',
            'KPP Pratama',
            'PT PLN',
            'BNN',
            'PT POS',
            'BRI',
            'Kementrian Agama',
            'ATR / BPN',
            'Kementerian Agama',
            'Perumda Air Minum Tirta Senentang',
            'CU Keling Kumang',
            'CU Bima',
         ],
         fields: [
            {
               key: 'no', label: 'No', sortable: false, thClass: 'text-center align-middle',
            },
            { key: 'saran', label: 'Saran', sortable: false },
            {
               key: 'nilai', label: 'Nilai', sortable: false, thClass: 'text-center align-middle',
            },
         ],
      }
   },
   computed: {
      ...mapState({
         saran: state => state.DashboardSkm.saran,
         tahun: state => state.DashboardSkm.tahun,
         refreshTimestamp: state => state.DashboardSkm.refreshTimestamp,
         skin: state => state.appConfig.layout.skin,
      }),
      isDark() {
         return this.skin === 'dark'
      },
      tableItems() {
         return (this.saran.data || []).slice(0, 10).map((item, index) => ({
            no: index + 1,
            saran: item.saran,
            nilai: item.nilai,
         }))
      },
   },
   watch: {
      tahun(newYear, oldYear) {
         if (newYear !== oldYear) this.loadData({ year: newYear, instansi: this.instansi })
      },
      instansi(newInstansi, oldInstansi) {
         if (newInstansi !== oldInstansi) this.loadData({ year: this.tahun, instansi: newInstansi })
      },
      refreshTimestamp() {
         this.loadData({ year: this.tahun, instansi: this.instansi })
      },
   },
   mounted() {
      this.loadData({ year: this.tahun, instansi: this.instansi })
   },
   methods: {
      ...mapActions({
         getSaran: 'DashboardSkm/getSaran',
      }),
      async loadData(params) {
         this.loading = true
         try {
            await this.getSaran(params)
         } catch (error) {
            // Tabel tetap menampilkan data kosong saat request gagal.
         } finally {
            this.loading = false
         }
      },
      formatNilai(nilai) {
         const number = Number(String(nilai || '').replace(',', '.'))

         if (Number.isNaN(number)) return nilai || '-'

         return number.toLocaleString('id-ID', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
         })
      },
   },
}
</script>

<template>
   <b-overlay
      :show="loading"
      :variant="isDark ? 'dark' : 'white'"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
   >
      <b-row>
         <b-col cols="12">
            <b-card
               class="card-wrapper"
               :class="{ 'card-wrapper-dark': isDark }"
            >
               <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-1">
                  <div class="mb-1 mb-md-0">
                     <h4 class="mb-25">
                        Top 10 Saran Terbaru
                     </h4>
                     <small class="text-muted">Sepuluh saran terbaru Tahun {{ tahun }}</small>
                  </div>
                  <div class="saran-toolbar">
                     <label class="sr-only" for="skm-saran-instansi">Instansi</label>
                     <v-select
                        id="skm-saran-instansi"
                        v-model="instansi"
                        :options="instansiOptions"
                        :clearable="false"
                        :reduce="option => option"
                        placeholder="Pilih Instansi"
                     />
                  </div>
               </div>

               <b-table
                  :items="tableItems"
                  :fields="fields"
                  responsive
                  striped
                  hover
                  show-empty
                  empty-text="Belum ada data"
                  class="saran-table"
               >
                  <template #cell(no)="data">
                     <span class="font-weight-bolder">{{ data.item.no }}</span>
                  </template>

                  <template #cell(saran)="data">
                     <span class="text-wrap">{{ data.item.saran }}</span>
                  </template>

                  <template #cell(nilai)="data">
                     <b-badge variant="light-primary" class="font-weight-bolder">
                        {{ formatNilai(data.item.nilai) }}
                     </b-badge>
                  </template>
               </b-table>
            </b-card>
         </b-col>
      </b-row>
   </b-overlay>
</template>

<style scoped>
.card-wrapper {
   border: 0;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
   background-color: #ffffff;
}

.card-wrapper-dark {
   background-color: #283046;
   box-shadow: 0 4px 24px rgba(0, 0, 0, 0.25);
}

.saran-toolbar {
   min-width: 260px;
   width: 100%;
}

@media (min-width: 768px) {
   .saran-toolbar {
      width: 300px;
   }
}

.saran-table :deep(th) {
   vertical-align: middle;
}

.saran-table :deep(td) {
   vertical-align: middle;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
